import { getImportChanges } from '../../data/apis/api';
import { useRestQuery, errorHandler } from '../../data/util';
import { QueryKey } from './config';

export const useImportEntityChanges = (transpilerId: string, disabled?: boolean) => {
  const data = useRestQuery([QueryKey, 'ImportChanges', transpilerId], () => getImportChanges(transpilerId), {
    retry: false,
    enabled: !!transpilerId && !disabled,
    refetchOnMount: true,
    onError: errorHandler,
    sentryTag: 'transpiler.importEntityChanges'
  });

  return data;
};
